import React, { FC, useEffect, useState } from 'react';
import { Grid, View } from '@adobe/react-spectrum';

import '~/Assets/main.sass';
import { Canvas } from '../../Pages/Studio/Canvas';
import { createProject } from '~/Services/Studio/studioSceneBuilder';
import { LOCAL_JSON } from '~/Services/Environment/devConfig';
import { _system, _engine } from '~/Services/Studio/studioScene';
import Comments from './comments';

const Layout: FC = () => {
    const [isReady, setIsReady] = useState(false);
    const areas = [
        'center right'
    ];
    const columns = ['auto', 'size-3600'];
    const rows = [
        'auto'
    ];

    useEffect(() => {
        createProject(LOCAL_JSON, () => {
            setIsReady(true)
        });


    }, []);

    return (
        <Grid
            areas={areas}
            columns={columns}
            rows={rows}
            height="100vh"
        >
            <View gridArea="center" UNSAFE_style={{ background: 'white' }}>
                <Canvas />
            </View>
            <View gridArea="right" padding="size-200">
                {isReady && <Comments/>}
            </View>
        </Grid>
    );
};

export default Layout;
